import React, { useEffect, useState } from 'react';
function Splash({ onSplashComplete }) {
    const fullOrigin = window.location.origin;
  const hostname = window.location.hostname;
  const origin = hostname
    .replace(/^www\./, '')
    .replace(/\.(com|live|net|bet|buzz|win|world)$/i, '');
  

  
  const [imageError, setImageError] = useState(false);
  const [visible, setVisible] = useState(true);
  const [imageSrc, setImageSrc] = useState(`${process.env.PUBLIC_URL}/splash/${origin}.gif`);
  
  // This useEffect guarantees the splash screen stays visible for exactly 2 seconds
  useEffect(() => {
    let fadeTimer = null;
    console.log("Splash screen - Starting 2-second timer");
    // Force splash screen to show for exactly 2 seconds, regardless of data loading
    const displayTimer = setTimeout(() => {
      console.log("Splash screen - 2 seconds elapsed, starting fade out");
      
      // Add a class to fade out the splash screen
      const splashElement = document.querySelector('.splash-screen');
      if (splashElement) {
        splashElement.classList.add('fade-out');
      }
      
      // After the fade animation completes, call the completion callback and remove from DOM
      fadeTimer = setTimeout(() => {
        console.log("Splash screen - Fade out complete, removing from DOM");
        setVisible(false); // Remove from DOM completely
        if (onSplashComplete) {
          console.log("Splash screen - Calling onSplashComplete callback");
          onSplashComplete();
        }
      }, 500); // 500ms for fade-out animation
    }, 2000); // Always show for exactly 2000ms (2 seconds)

    // Clean up both timers if component unmounts
    return () => {
      clearTimeout(displayTimer);
      if (fadeTimer) clearTimeout(fadeTimer);
    };
  }, [onSplashComplete]);

  const handleImageError = () => {
    // If the domain-specific image fails, try default.gif
    if (imageSrc.includes(`${origin}.gif`)) {
      console.log(`Splash image ${origin}.gif not found, falling back to default.gif`);
      setImageSrc(`${process.env.PUBLIC_URL}/splash/default.gif`);
    } else {
      // If default.gif also fails, show loading animation
      console.log("Default splash image also failed, showing loading animation");
      setImageError(true);
    }
  };

  const lazy = () => {
    // Image loaded successfully, no action needed
  };

  // Don't render anything if not visible
  if (!visible) return null;
  return (
    
   <>
    <div className="splash-screen">
      <div className="splash-content">
        <img src={imageSrc}
          onError={handleImageError}
          onLoad={lazy} alt="BigTaka Logo" className="splash-logo" />
      </div>
      
    </div>
    <div className="v-overlay theme--dark " style={{zIndex: 300}}><div className="v-overlay__scrim" style={{opacity: 0.8, backgroundColor: 'rgb(33, 33, 33)', borderColor: 'rgb(33, 33, 33)'}} /></div></>
  );
}

export default Splash;
